import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCross = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
        <path
            fill="currentColor"
            d="m12.075 9.905 4.903-4.903 2.182 2.182-4.903 4.903 4.952 4.953-2.182 2.182-4.952-4.953-4.891 4.891-2.182-2.182 4.89-4.891-5-5.001 2.181-2.183z"
        />
    </svg>
);
export default SvgCross;
